// Util de normalização de strings para uso como classe CSS.
//
// Sessão 19 (TD86 audit, Bug 2): vários componentes usavam apenas
// `.toLowerCase()` pra montar nome de classe a partir de valores que
// vêm da IA com acentos ("Média", "Crítica"). Resultado: a classe
// gerada (ex: `severity-badge média`) não casa com o CSS que está
// definido sem acento (`.severity-badge.media`) — badge cai no default
// sem cor. Sintoma visual: NCs com severidade "Média" ou "Crítica"
// ficavam sem destaque.
//
// Esta função normaliza removendo diacríticos via NFD + filtro do
// bloco Unicode de combining marks (U+0300 a U+036F), depois lowercase.
// Use sempre que for compor `className=...${valor}...` a partir de
// string vinda da IA ou de qualquer entrada com acentos.
//
// Exemplos:
//   cssSlug('Média')    === 'media'
//   cssSlug('Crítica')  === 'critica'
//   cssSlug('Alta')     === 'alta'
//   cssSlug('médio')    === 'medio'
//   cssSlug(undefined)  === ''
//   cssSlug(null)       === ''
//   cssSlug('')         === ''
export function cssSlug(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

export default cssSlug;
